module.exports = __webpack_public_path__ + "img/pallets44.9bde64fd.png";